import {
  Address,
  GetGeoInfoParams,
  GetIsValidAddressResponse,
} from '../../../models/address.models';
import { BuilderType, mlkOnQueryStarted, InvalidationTag } from '../../utils';

export const buildUpsertAddress = (builder: BuilderType) =>
  builder.mutation<Address, Partial<Address>>({
    onQueryStarted: mlkOnQueryStarted,
    query: (body) => ({
      url: `/addresses/upsert`,
      method: 'POST',
      body,
    }),
    invalidatesTags: () => [{ type: InvalidationTag.Addresses }],
  });

export const buildDeleteAddress = (builder: BuilderType) =>
  builder.mutation<{}, string>({
    onQueryStarted: mlkOnQueryStarted,
    query: (addressId) => ({
      url: `/addresses/${addressId}`,
      method: 'DELETE',
    }),
    invalidatesTags: () => [{ type: InvalidationTag.Addresses }],
  });

export const buildGetAddresses = (builder: BuilderType) =>
  builder.query<{ data: Address[] }, undefined>({
    onQueryStarted: mlkOnQueryStarted,
    query: () => `/addresses`,
    providesTags: () => [{ type: InvalidationTag.Addresses }],
  });

export const buildIsValidAddress = (builder: BuilderType) =>
  builder.mutation<GetIsValidAddressResponse, string>({
    onQueryStarted: mlkOnQueryStarted,
    query: (zipCode: string) => `/addresses/territoryId/${zipCode}`,
  });

export const buildGeoInfo = (builder: BuilderType) =>
  builder.mutation<Array<string>, GetGeoInfoParams>({
    onQueryStarted: mlkOnQueryStarted,
    query: (params) => ({ url: `/geo-info`, params }),
  });
